import { VehicleInspectionItemType } from './vehicle-inspection-item-type';
import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class VehicleInspectionItem extends AbstractModel {
  @autoserializeAs(VehicleInspectionItemType)
  vehicleInspectionItemType: VehicleInspectionItemType;

  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;
}
